import Button from 'components/base/Button';
import Input from 'components/common/form/input/Input';
import Select from 'components/common/form/select/Select';
import { Form, Formik } from 'formik';
import React from 'react';
import { FormGroup, FormLabel } from 'react-bootstrap';
import { genderOptions } from './config';
import * as Yup from 'yup';
import { useStudentRegisterMutation } from 'service/institutionQuery/institutionQuery';
import { useNavigate, useParams } from 'react-router-dom';

const validationSchema = Yup.object({
  username: Yup.string()
    .required('Username is required')
    .min(3, 'Username must be at least 3 characters')
    .max(20, 'Username cannot exceed 20 characters'),
  registerNumber: Yup.string()
    .required('Register Number is required')
    .matches(/^[a-zA-Z0-9]+$/, 'Register Number must be alphanumeric'),
  gender: Yup.string()
    .required('Gender is required')
    .oneOf(
      ['male', 'female', 'other'],
      'Gender must be Male, Female, or Other'
    ),

  email: Yup.string()
    .required('Email is required')
    .email('Enter a valid email address'),

  contactNumber: Yup.string()
    .required('Contact Number is required')
    .matches(/^[0-9]+$/, 'Contact Number must be numeric')
    .min(10, 'Contact Number must be at least 10 digits')
    .max(15, 'Contact Number cannot exceed 15 digits')
});

type FormValues = {
  registerNumber: string;
  username: string;
  email: string;
  gender: string;
  contactNumber: string;
};

function InstitutionStudentForm() {
  const { id } = useParams();
  const [studentRegister, { isLoading }] = useStudentRegisterMutation();

  const navigate = useNavigate();

  const handleSubmit = (values: FormValues) => {
    studentRegister({ id, ...values })
      .unwrap()
      .then(response => {
        const id = response?.data?._id;
        navigate(`/verify/sent/student/${id}`);
      })
      .catch(console.error);
  };
  return (
    <>
      <div className="position-relative mt-4">
        <hr className="bg-body-secondary" />
        <div className="divider-content-center">Student</div>
      </div>
      <Formik
        initialValues={{
          registerNumber: '',
          username: '',
          email: '',
          gender: '',
          contactNumber: ''
        }}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={handleSubmit}
      >
        <Form>
          <FormGroup className="mb-3 text-start">
            <FormLabel htmlFor="registerNumber">Register Number</FormLabel>
            <Input name="registerNumber" id="registerNumber" />
          </FormGroup>
          <FormGroup className="mb-3 text-start">
            <FormLabel htmlFor="username">Name</FormLabel>
            <Input name="username" id="username" placeholder="Ex: John" />
          </FormGroup>
          <FormGroup className="mb-3 text-start">
            <FormLabel htmlFor="email">Email address</FormLabel>
            <Input
              name="email"
              id="email"
              type="email"
              placeholder="name@example.com"
            />
          </FormGroup>
          <FormGroup className="mb-3 text-start">
            <FormLabel htmlFor="contactNumber">Contact Number</FormLabel>
            <Input name="contactNumber" id="contactNumber" />
          </FormGroup>
          <FormGroup className="mb-3 text-start">
            <FormLabel htmlFor="gender">Gender</FormLabel>
            <Select name="gender" id="gender" options={genderOptions} />
          </FormGroup>
          <Button
            variant="primary"
            type="submit"
            className="w-100 mb-3"
            loading={isLoading}
            loadingPosition="start"
          >
            Sign Up
          </Button>
        </Form>
      </Formik>
    </>
  );
}

export default InstitutionStudentForm;
